import React from "react";
import useGet from "../hooks/useGet";
import { Apis } from "../util/Apis";
import CustomLoading from "./CustomLoading";
import NoSorteos from "./NoSorteos";
import Text from "../styledComponents/TextStyled";
import { BackgroundListRaffle } from "../pages/SorteoList";
import CardProgressive from "./CardProgressive";
import EmptyState from "./EmptyState";

const ProgressiveListTab = () => {
  const {
    data: dataProgressive,
    loading: loadingProgressive,
    error: errorProgressive,
  } = useGet({
    url: `${Apis.TGM}/progressive`,
  });

  return (
    <>
      {loadingProgressive ? (
        <CustomLoading />
      ) : errorProgressive ? (
        <NoSorteos>
          <Text textStyle="small" color="red">
            {errorProgressive.message || "Ocurrió un error al cargar los progresivos"}
          </Text>
        </NoSorteos>
      ) : dataProgressive?.length > 0 ? (
        <BackgroundListRaffle className="custom-scroll">
          {dataProgressive.map((item) => (
            <CardProgressive key={item.id} item={item} />
          ))}
        </BackgroundListRaffle>
      ) : (
        <EmptyState variant="misteriosos" />
      )}
    </>
  );
};

export default ProgressiveListTab;
